import { createOrUpdateClinicianStartingPostcode } from '../../../actions/areas/admin/commandActions';

export const eventHandlers = (state, setState, auth) => ({
  refreshTable: () => setState({ ...state, forceReload: !state.forceReload, startingPostingList: {} }),
  updateTableProps: (currentPage, pageSize) => setState({ ...state, currentPage, pageSize }),
  updateTableSort: (sortColumn, sortDirection) => setState({ ...state, sortColumn, sortDirection }),
  onFiltersChange: model =>
    setState({
      ...state,
      cliniciansBySurname: model.surname,
      orgUnitId: model.orgUnitId,
      currentPage: 1,
      startingPostingList: {},
    }),
  onInvalidPostcode: updateModel => {
    // eslint-disable-next-line no-use-before-define
    update(updateModel, state, setState);
  },
  updateStartingPostcodeValue: updateModel => {
    // eslint-disable-next-line no-use-before-define
    update(updateModel, state, setState);
  },
  updateButtonText: 'Update Starting Postcode',
  handleUpdateEvent: () => {
    const updatedStartingPostcodes = Object.values(state.startingPostingList);
    const containsInvalidPostCodes = updatedStartingPostcodes.some(x => x.isInvalidStartingPostcode === true);

    if (state.startingPostingList !== 0 && containsInvalidPostCodes === false) {
      createOrUpdateClinicianStartingPostcode(auth, { ClinicianStartingPostcodes: updatedStartingPostcodes }, () =>
        setState({ ...state, startingPostingList: {}, forceReload: !state.forceReload }),
      );
    }
  },
});

const update = (updateModel, state, setState) => {
  setState({
    ...state,
    startingPostingList: { ...state.startingPostingList, [updateModel.clinicianId]: updateModel },
  });
};
